import type { Hex } from 'viem'

import { Time } from '@morpho-org/morpho-ts'

import type { HistoryRange } from '@/lib/transforms/history/window'

import { orpc } from '@/lib/orpc/client'

/** Above 0, so what the server prefetched is not refetched as soon as the page hydrates. */
const MARKET_HISTORY_STALE_TIME_MS = 5 * 60_000

/** The chart's timeframe options as the procedure's ranges; `null` is "All time". */
export function toHistoryRange(timeFrame: Time.PeriodLike | null): HistoryRange {
  if (timeFrame === null) return 'all'
  const seconds = Time.s.fromPeriod(timeFrame)
  if (seconds <= Time.s.fromPeriod('w')) return '1w'
  if (seconds <= Time.s.fromPeriod('mo')) return '1m'
  return '3m'
}

/** One set of options for the server prefetch and the client read, so their keys match. */
export function marketHistoryQueryOptions(input: {
  chainId: number
  marketId: Hex
  range: HistoryRange
}) {
  return orpc.market.history.queryOptions({ input, staleTime: MARKET_HISTORY_STALE_TIME_MS })
}
